import { createSlice } from '@reduxjs/toolkit';
import { EmployeesSearchTypes } from 'src/components/ToggleBox/ToggleBox.types';
import { SortTypes } from 'src/screens/employees/EmployeesScreen.types';

import { InitialEmployeeStateType } from '../types/employeeTypes';
const name = 'employees';

const INITIAL_STATE: InitialEmployeeStateType = {
  employees: [],
  filteredEmployees: [],
  isEmployeesLoading: false,
  isFilteredEmployeesLoading: false,
  selectedToggleBoxValue: EmployeesSearchTypes.STUDIO,
  sortByValue: SortTypes.NAME,
  searchInputValue: '',
  searchParams: null,
  error: null,

  isAddRequestLoading: false,
  isInviteRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
  isEmployeeStatusLoading: false,
};

const EmployeesSlice = createSlice({
  name,
  initialState: INITIAL_STATE,
  reducers: {
    updateSearchParams: (state, action) => {
      const { selectedToggleBox, searchInput, sortBy } = action.payload;
      state.selectedToggleBoxValue = selectedToggleBox;
      state.searchInputValue = searchInput;
      state.sortByValue = sortBy;
    },

    getEmployees: state => {
      state.isEmployeesLoading = true;
    },
    getEmployeesSuccess: (state, action) => {
      state.isEmployeesLoading = false;
      state.employees = action.payload;
    },
    getEmployeesFailure: (state, action) => {
      state.isEmployeesLoading = false;
      state.error = action.payload;
    },

    getFilteredEmployees: (state, action) => {
      state.isFilteredEmployeesLoading = true;
      state.searchParams = action.payload;
    },
    getFilteredEmployeesSuccess: (state, action) => {
      state.isFilteredEmployeesLoading = false;
      state.filteredEmployees = action.payload;
    },
    getFilteredEmployeesFailure: (state, action) => {
      state.isFilteredEmployeesLoading = false;
      state.error = action.payload;
    },

    addEmployee: (state, action) => {
      state.isAddRequestLoading = true;
    },
    addEmployeeSuccess: state => {
      state.isAddRequestLoading = false;
    },
    addEmployeeFailure: (state, action) => {
      state.isAddRequestLoading = false;
      state.error = action.payload;
    },

    inviteEmployees: (state, action) => {
      state.isInviteRequestLoading = true;
    },
    inviteEmployeesSuccess: state => {
      state.isInviteRequestLoading = false;
    },
    inviteEmployeesFailure: (state, action) => {
      state.isInviteRequestLoading = false;
      state.error = action.payload;
    },

    updateEmployees: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateEmployeesSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateEmployeesFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeEmployees: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeEmployeesFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
    removeEmployeesSuccess: state => {
      state.isRemoveRequestLoading = false;
    },

    getEmployeeStatus: (state, action) => {
      state.isEmployeeStatusLoading = true;
    },
    getEmployeeStatusSuccess: state => {
      state.isEmployeeStatusLoading = false;
    },
    getEmployeeStatusFailure: (state, action) => {
      state.isEmployeeStatusLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSearchParams,

  getEmployees,
  getEmployeesFailure,
  getEmployeesSuccess,

  getFilteredEmployees,
  getFilteredEmployeesSuccess,
  getFilteredEmployeesFailure,

  addEmployee,
  addEmployeeSuccess,
  addEmployeeFailure,

  inviteEmployees,
  inviteEmployeesSuccess,
  inviteEmployeesFailure,

  updateEmployees,
  updateEmployeesSuccess,
  updateEmployeesFailure,

  removeEmployees,
  removeEmployeesFailure,
  removeEmployeesSuccess,

  getEmployeeStatus,
  getEmployeeStatusSuccess,
  getEmployeeStatusFailure,
} = EmployeesSlice.actions;

export default EmployeesSlice.reducer;
